// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"442":"0feeb9ff53e2f99c","471":"328cfdd532ca39d2"}[chunkId] + ".js";
};